var map = {
	"./AccountHolders.svg": 96736,
	"./AddressVerification.svg": 89419,
	"./Cards.svg": 61519,
	"./CoreAPI.svg": 77953,
	"./DWT.svg": 5087,
	"./Dashboard.svg": 10434,
	"./DiVA.svg": 58944,
	"./JIT.svg": 41859,
	"./KeyConcepts.svg": 92360,
	"./MoneyMovement.svg": 48885,
	"./PlatformFeatures.svg": 85270,
	"./SDKs.svg": 1189,
	"./SpendControls.svg": 63244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28899;